import type { ShareableScopeKind } from "../../../../shared/rbac/permissions";
import { navigate, routes } from "../../../lib/urls";
import type { RouteNode } from "../../../lib/urls/types";

const RESOURCE_ROUTES = {
  space: routes.modal.space,
  connected_app: routes.modal.connector,
  skill: routes.modal.skill,
  network: routes.modal.network,
  service_account: routes.modal.serviceAccount,
} satisfies Record<ShareableScopeKind, RouteNode>;

export function useOpenResource() {
  const openResource = (scopeId: string, scopeKind: ShareableScopeKind) => {
    navigate(RESOURCE_ROUTES[scopeKind], { id: scopeId });
  };

  return { openResource };
}
